var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterboxd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "letterboxd",
    fill: "#d5def5",
    cx: 250,
    cy: 250,
    r: 250
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(61 180)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#202830",
    cx: 189,
    cy: 70,
    r: 70
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#202830",
    cx: 308,
    cy: 70,
    r: 70
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#202830",
    cx: 70,
    cy: 70,
    r: 70
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.54 107.06c-6.73-10.75-10.62-23.45-10.62-37.06 0-13.61 3.89-26.32 10.62-37.06 6.73 10.74 10.62 23.45 10.62 37.06 0 13.61-3.89 26.31-10.62 37.06",
    fill: "#d5def5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.46 32.94c6.73 10.75 10.62 23.45 10.62 37.06 0 13.61-3.89 26.32-10.62 37.06-6.73-10.75-10.62-23.45-10.62-37.06 0-13.61 3.89-26.32 10.62-37.06",
    fill: "#d5def5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterboxd);
export default __webpack_public_path__ + "static/media/Letterboxd.89b415756aed7d8c778adcff4294739e.svg";
export { ForwardRef as ReactComponent };